export const environment = {
  campaignEmbeddedCheckout: true,
  production: true,
  apiUrl: 'https://api.ontariosecuritylicense.ca/v1',
  googleOAuthClientId: '1094998117677-mjumrmm0brhba0620dn041betp33h77t.apps.googleusercontent.com',
  stripePublishableKey: 'pk_live_51LkXeWFOL7gdXuKGQdbciVh3hFce359IKuGMpTLdZF7SDQBMOmcPHu4MCmcanoYVIWKAQL1OLTfNnrANwcDZBpgn00ygkkeJX6',
  googleAPIKey: 'AIzaSyCRaRHWTcibdP2nCwq3lb9h9fCg27meKSk',
  // 'mock' needs no backend (development only); a production build refuses it.
  campaignApi: 'live' as 'mock' | 'live',
  forcePromo: false,
  forceMultiPromo:false,
  checkoutRecoveryEnabled: false,

  // The API must authorize each paid event; its activation flags and watermark
  // remain the release gate. Development and staging keep Purchase disabled.
  metaPurchasePixelEnabled: true,
  metaPurchasePixelId: '1163840941256698',
  // Published on 1 October 2026. Match META_PURCHASE_POLICY_VERSION on the API
  // when Stage 4 is activated; an empty API version still withholds the envelope.
  metaAdvertisingConsentVersion: '2026-10-01'
};
